import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { AuthProvider } from './auth/AuthProvider';
import AutoLogout from './components/AutoLogout';
import ErrorBoundary from './components/ErrorBoundary';
import Toastify from './components/Toastify';
import { ConfigProvider } from './context/ConfigProvider';
import { FeatureGateProvider } from './context/FeatureGate/FeatureGateContext';
import { GlobalProvider } from './context/GlobalProvider';
import { ProductTourProvider } from './context/ProductTourContext';
import { UserProvider } from './context/UserProvider';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false } } });

const Providers = ({ children }: { children: ReactNode }) => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <UserProvider>
          <FeatureGateProvider>
            <GlobalProvider>
              <ConfigProvider>
                <ProductTourProvider>
                  <Toastify />
                  {children}
                  <AutoLogout />
                </ProductTourProvider>
              </ConfigProvider>
            </GlobalProvider>
          </FeatureGateProvider>
        </UserProvider>
      </AuthProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default Providers;
